export default __webpack_public_path__ + "static/milann-4242370fa50472191668d327b9eba89c.svg";